import { render } from "./DataControllerSection.vue?vue&type=template&id=31b4daf2"
import script from "./DataControllerSection.vue?vue&type=script&lang=js"
export * from "./DataControllerSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__